@if (!errorMessage) {
  <div class="cssload-container">
    <div class="cssload-speeding-wheel"></div>
  </div>
}
<div class="row">
  <div class="col-xs-offset-4 col-md-offset-6 col-xs-12 col-md-5">
    <div class="choose-name-login">Redirection</div>
    @if (errorMessage) {
      <div class="choose-name-login">
        {{ errorMessage }}
      </div>
    }
  </div>
</div>
